import { FC } from 'react';
import ScriptsTable from 'components/Tables/ScriptsTable';
import { useMyTranslations } from 'hooks/useMyTranslations';
import { scriptsTranslations } from './translations';
import { ScriptsTransFields } from './types';
import styles from './parsers.module.scss';

const Scripts: FC = () => {
  const { t } = useMyTranslations<ScriptsTransFields>([scriptsTranslations.name]);

  return (
    <main className={styles.page}>
      <header className={styles.header}>
        <h2 className={styles.headerTitle}>{t('title')}</h2>
      </header>
      <div className={styles.container}>{<ScriptsTable />}</div>
    </main>
  );
};

export default Scripts;
